import { Editor } from '@tldraw/tldraw'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { MobileButton } from 'components/MobileButton/MobileButton'
import { ImageShapeUtil } from 'components/VisualStudioPlayground/Shapes/ImageShape/ImageShapeUtil'
import Expand2 from 'blaze-ui/icons/20/Expand2'
import { isValidRotation } from 'components/VisualStudioPlayground/VisualEditor/components/Toolbars/ImageToolbar/components/FillCanvasButton'

interface Props {
  editor: Editor
  selectedShape: ImageShape
}

export const MobileFillCanvasButton = ({ editor, selectedShape }: Props) => {
  const util = editor.getShapeUtil(selectedShape) as ImageShapeUtil

  if (!isValidRotation(selectedShape.rotation)) {
    return null
  }

  return (
    <MobileButton
      variant="secondary"
      onPress={() => {
        util.fitShapeToCanvas(selectedShape)
      }}
      icon={Expand2}
    >
      <div style={{ display: 'flex' }}>Fill Canvas</div>
    </MobileButton>
  )
}
